import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {NewsTabModel} from "../news.tab-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";
import {CompetitorNewsPageLinkModel} from "../../../../../containers/competitor-container/pages/news-page/models/competitor.news-page.link-model";

export class CompetitorNewsPageTabModel extends NewsTabModel {
  @computed get linkModel(): CompetitorNewsPageLinkModel {
    const linkModel: CompetitorNewsPageLinkModel = new CompetitorNewsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === NEW_COMPETITOR_CONTAINER.FILTERS.news
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_news';
  }
}
